import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import UnknownMonoHtmlView from './UnknownHtml';
import UnknownMonoReactView from './Unknown';
const UnknownMonoView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(UnknownMonoHtmlView, _extends({}, props));
    }
    return /*#__PURE__*/ React.createElement(UnknownMonoReactView, _extends({}, props));
};
UnknownMonoView.displayName = 'UnknownMonoView';
export default UnknownMonoView;
